<template>
  <div v-if="$store.state.responsive.viewDesktopFilters">
    <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
      <div class="row">
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="documentNumber">DNI</label>
            <input type="text" class="form-control generalInput" id="documentNumber"
              v-model.trim.lazy="v$.documentNumber.$model"
              :disabled="street != '' || number != '' || postalCode != '' || email != '' || mobile != '' || surname != ''">
            <div v-if="v$.documentNumber.$dirty">
              <small class="form-text text-danger" v-if="v$.documentNumber.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="surname">Apellido</label>
            <input type="text" class="form-control generalInput" id="surname" v-model.trim.lazy="v$.surname.$model"
              :disabled="street != '' || number != '' || postalCode != '' || documentNumber != '' || email != '' || mobile != ''">
            <div v-if="v$.surname.$dirty">
              <small class="form-text text-danger" v-if="v$.surname.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="mobile">Teléfono</label>
            <input type="text" class="form-control generalInput" id="mobile" v-model.trim.lazy="v$.mobile.$model"
              :disabled="street != '' || number != '' || postalCode != '' || documentNumber != '' || email != '' || surname != ''">
            <div v-if="v$.mobile.$dirty">
              <small class="form-text text-danger" v-if="v$.mobile.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="email">Email</label>
            <input type="text" class="form-control generalInput" id="email" v-model.trim.lazy="v$.email.$model"
              :disabled="street != '' || number != '' || postalCode != '' || documentNumber != '' || mobile != '' || surname != ''">
            <div v-if="v$.email.$dirty">
              <small class="form-text text-danger" v-if="v$.email.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="street">Calle</label>
            <input type="text" class="form-control generalInput" id="street" v-model.trim="street"
              :disabled="documentNumber != '' || mobile != '' || email != '' || surname != ''"
              :required="number != '' || postalCode != ''">
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="number">Número</label>
            <input type="text" class="form-control generalInput" id="number" v-model.trim="number"
              :disabled="documentNumber != '' || mobile != '' || email != '' || surname != ''"
              :required="postalCode != '' || street != ''">
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="postalCode">Código postal</label>
            <input type="text" class="form-control generalInput" id="postalCode"
              v-model.trim.lazy="v$.postalCode.$model"
              :disabled="documentNumber != '' || mobile != '' || email != '' || surname != ''"
              :required="number != '' || street != ''">
            <div v-if="v$.postalCode.$dirty">
              <small class="form-text text-danger" v-if="v$.postalCode.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
            <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
            <button class="btn btn-primary generalPrimaryButton"
              :disabled="street == '' && number == '' && postalCode == '' && documentNumber == '' && mobile == '' && email == '' && surname == ''">Buscar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div v-else>
    <div class="filterHeader link-primary d-flex align-items-center justify-content-between" data-toggle="collapse" href="#filterCollapse" role="button" aria-expanded="true" aria-controls="filterCollapse">
      <p class="m-0">
        FILTROS
      </p>
      <v-icon name="bi-filter" scale="1.5" />
    </div>
    <hr/>
    <div class="collapse show" id="filterCollapse">
      <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
        <div class="row">
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="documentNumber">DNI</label>
              <input type="text" class="form-control generalInput" id="documentNumber"
                v-model.trim.lazy="v$.documentNumber.$model"
                :disabled="street != '' || number != '' || postalCode != '' || email != '' || mobile != '' || surname != ''">
              <div v-if="v$.documentNumber.$dirty">
                <small class="form-text text-danger" v-if="v$.documentNumber.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="surname">Apellido</label>
              <input type="text" class="form-control generalInput" id="surname" v-model.trim.lazy="v$.surname.$model"
                :disabled="street != '' || number != '' || postalCode != '' || documentNumber != '' || email != '' || mobile != ''">
              <div v-if="v$.surname.$dirty">
                <small class="form-text text-danger" v-if="v$.surname.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="mobile">Teléfono</label>
              <input type="text" class="form-control generalInput" id="mobile" v-model.trim.lazy="v$.mobile.$model"
                :disabled="street != '' || number != '' || postalCode != '' || documentNumber != '' || email != '' || surname != ''">
              <div v-if="v$.mobile.$dirty">
                <small class="form-text text-danger" v-if="v$.mobile.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="email">Email</label>
              <input type="text" class="form-control generalInput" id="email" v-model.trim.lazy="v$.email.$model"
                :disabled="street != '' || number != '' || postalCode != '' || documentNumber != '' || mobile != '' || surname != ''">
              <div v-if="v$.email.$dirty">
                <small class="form-text text-danger" v-if="v$.email.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="street">Calle</label>
              <input type="text" class="form-control generalInput" id="street" v-model.trim="street"
                :disabled="documentNumber != '' || mobile != '' || email != '' || surname != ''"
                :required="number != '' || postalCode != ''">
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="number">Número</label>
              <input type="text" class="form-control generalInput" id="number" v-model.trim="number"
                :disabled="documentNumber != '' || mobile != '' || email != '' || surname != ''"
                :required="postalCode != '' || street != ''">
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="postalCode">Código postal</label>
              <input type="text" class="form-control generalInput" id="postalCode"
                v-model.trim.lazy="v$.postalCode.$model"
                :disabled="documentNumber != '' || mobile != '' || email != '' || surname != ''"
                :required="number != '' || street != ''">
              <div v-if="v$.postalCode.$dirty">
                <small class="form-text text-danger" v-if="v$.postalCode.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
              <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
              <button class="btn btn-primary generalPrimaryButton"
                :disabled="street == '' && number == '' && postalCode == '' && documentNumber == '' && mobile == '' && email == '' && surname == ''">Buscar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import {
  email,
  numeric,
  minLength,
  maxLength
} from '@vuelidate/validators'

const dniNumber = (value) => {
  var numero, le, letra;
  var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

  value = value.toUpperCase();

  if (expresion_regular_dni.test(value) === true) {
    numero = value.substr(0, value.length - 1);
    numero = numero.replace('X', 0);
    numero = numero.replace('Y', 1);
    numero = numero.replace('Z', 2);
    le = value.substr(value.length - 1, 1);
    numero = numero % 23;
    letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
    letra = letra.substring(numero, numero + 1);
    if (letra != le) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

const alphaAccents = (value) => {
  if (/[a-zA-ZÀ-ÿ\u00f1\u00d1]{2,3}/gi.test(value))
    return true
  else return false
}

export default {
  name: 'BlackListFilter',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      documentNumber: '',
      surname: '',
      mobile: '',
      email: '',
      street: '',
      number: '',
      postalCode: '',
    };
  },
  validations() {
    return {
      email: {
        email,
      },
      mobile: {
        numeric,
        minLength: minLength(9),
      },
      surname: {
        alphaAccents,
      },
      documentNumber: {
        dniNumber
      },
      postalCode: {
        numeric,
        maxLength: maxLength(5),
      },
    }
  },
  computed: {
    filtersApplied() {
      // `this` apunta a la instancia vm
      return {
        documentNumber: this.documentNumber,
        mobile: this.mobile,
        email: this.email,
        street: this.street,
        surname: this.surname,
        number: this.number,
        postalCode: this.postalCode,
      };
    },
  },
  methods: {
    filter() {
      this.$emit('filter', this.filtersApplied);
    },
    cleanSearch() {
      this.documentNumber = '';
      this.v$.documentNumber.$dirty = false;
      this.mobile = '';
      this.surname = '';
      this.v$.surname.$dirty = false;
      this.email = '';
      this.street = '';
      this.number = '';
      this.postalCode = '';
    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        this.filter();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../scss/variables.scss';

.filterHeader {
  font-size: 1.143rem;
  line-height: 1.5;
}
.link-primary {
  color:$primary;
  cursor:pointer;

  &:hover {
    color: $primary-hover;
  }
}

</style>
